import { useContext } from 'react';

import { CFSContext } from '@/contexts';

export const useCFSContext = () => useContext(CFSContext);
